import React, { Component, createElement } from "react"
import $ from "jquery"
import "jquery-ui"
import "./RecordView.css"
import "./RecordViewFind.js"
import "../../VPLib/css/jquery-ui.css"
import "../../VPLib/css/ProductSpecificUI.css"
import { FieldedRecordView, RawRecordField } from "../../fetchData"
import "abortcontroller-polyfill/dist/polyfill-patch-fetch"
import { Loading } from "../../Loading"

var sort = function (prop, arr) {
	prop = prop.split(".")
	var len = prop.length
	arr.sort(function (a, b) {
		var i = 0
		while( i < len ) {
			a = a[1][prop[i]]
			b = b[1][prop[i]]
			i++
		}
		if (a < b) {
			return -1
		} else if (a > b) {
			return 1
		} else {
			return 0
		}
	})
	return arr
}

function RecordNotes (props){
	const RecordData = props.RecordData
	let NotesElementArray = []
	for (let info in RecordData){
		NotesElementArray.push(<div key={info}>{RecordData[info].Notes}</div>)
	}
	return NotesElementArray
}

function UpdateSelectedClasses(data){
	const checkboxes = document.getElementsByClassName("ClassificationCheckbox");
	let idArray = [];
	for (var i=0; i<checkboxes.length; i++){
		checkboxes[i].checked = false;
		idArray.push(checkboxes[i].id)
	}
	const RecordData = data
	for (let rec in RecordData){
		const classID = JSON.parse(RecordData[rec].classification)
		for (let subclass in classID){
			const myKeys = Object.keys(classID[subclass]);
			for (let key in myKeys){
				if (idArray.indexOf(myKeys[key]) > -1){
					document.getElementById(myKeys[key]).checked = true;
				}
			}
		}
	}
}
function Classifications(props){
	const classes = JSON.parse(props.ClassificationFields)
	let elems = []
	for (let elem in classes){
		let subElems = []
		if (classes[elem].allowmultiselect){

			for (let i=0; i<classes[elem].groupcount; i++){
				subElems.push(
					<div key={classes[elem]["group" + i].id}><input id={classes[elem]["group" + i].id} className="ClassificationCheckbox" name={classes[elem]} type="checkbox" disabled={true}></input><label htmlFor={classes[elem]["group" + i].id}>{classes[elem]["group" + i].name}</label></div>
				)
			}
		}
		else {			
			for (let i=0; i<classes[elem].groupcount; i++){
				subElems.push(
					<div key={classes[elem]["group" + i].id}><input id={classes[elem]["group" + i].id} className="ClassificationCheckbox" name={classes[elem]} type="checkbox" disabled={true}></input><label htmlFor={classes[elem]["group" + i].id}>{classes[elem]["group" + i].name}</label></div>
				)
			}

		}

		elems.push (
			<div key={elem}>{classes[elem].name}</div>
		)
		elems = elems.concat(subElems)
	}
	
	return elems
}
function RawRecord (props) {
	const RecordLinks = props.RecordLink;
	let elems = []
	RecordLinks.map((link, num) => {
		elems.push (
			<div key={num} className="RawRecordContainer">
				<iframe src={link[0].toString()} style={{height: '100%', width: '100%'}}></iframe>
			</div>
		)
	})
	return elems
}
function Record (props){
	const objToParse = JSON.parse(props.fields.fields)
	var sortedObj = sort("order", Object.entries(objToParse))
	var tables = []
	const viewType = props.ViewType
	switch (viewType) {
	case "Table":
		$("#recTable").addClass("checked")
		$("#recRow").removeClass("checked")
		$("#recCol").removeClass("checked")
		break
	case "Row":
		$("#recTable").removeClass("checked")
		$("#recRow").addClass("checked")
		$("#recCol").removeClass("checked")
		break
	case "Column":
		$("#recTable").removeClass("checked")
		$("#recRow").removeClass("checked")
		$("#recCol").addClass("checked")
		break
	default:
		$("#recTable").addClass("checked")
		$("#recRow").removeClass("checked")
		$("#recCol").removeClass("checked")
		break
	}
	if (Object.keys(props.RecordData).length > 1){
		//disable Prev/Next
	}
	if (viewType === "Row"){
		let theadrow = []
		let rows = []
		theadrow.push(<th key="TextHeader">Record</th>)
		for (let value in sortedObj){
			theadrow.push(<th key={sortedObj[value][0]}>{sortedObj[value][1].name}</th>)
		}
		let recordNum = 1
		for (let recordNumber in props.RecordData){
			let dataRow = []
			dataRow.push(<td key={recordNumber}>{"Record " + recordNum}</td>)
			recordNum++
			{for (let value in sortedObj){
				let data = JSON.parse(props.RecordData[recordNumber][sortedObj[value][0]])
				dataRow.push(
					<td key={value + "-" + recordNumber}> {data.map(function(x, i) {
						if (x.name.match(/^https?\:/)) {
							return (
								<div key={recordNumber + "-" + value + "-" + i}>
									<a className="Decorate" href={x.name}
										target="_blank">
										{x.name}
									</a>
								</div>
							)
						}
						else {
							
							return (
								<div key={recordNumber + "-" + value + "-" + i}>{x.name}</div>
							)
						}
					})
					}
					</td>
				)
			
			}}
			rows.push(<tr key={recordNumber}>{dataRow}</tr>)
		}
		tables.push(
			<table key={"table"} className="FieldedRecordViewRow">
				<thead><tr>{theadrow}</tr></thead>
				<tbody id="bodyelem">{rows}</tbody>
			</table>
		)
	}
	else if (viewType === "Column"){
		let theadrow = []
		let rows = []
		theadrow.push(<th key="FieldName">Field Name</th>)
		let recordNum = 1
		for (let recordNumber in props.RecordData){
			theadrow.push(<th key={recordNumber}>{"Record " + recordNum}</th>)
			recordNum++;
		}
		for (let value in sortedObj){
			let dataRow = []
			dataRow.push(<td key={value + "-1"}>{sortedObj[value][1].name}</td>)
			for (let recordNumber in props.RecordData){
				let data = JSON.parse(props.RecordData[recordNumber][sortedObj[value][0]])
				dataRow.push(
					<td key={value + "-" + recordNumber}> {data.map(function(x, i) {
						if (x.name.match(/^https?\:/)) {
							return (
								<div key={recordNumber + "-" + value + "-" + i}>
									<a className="Decorate" href={x.name}
										target="_blank">
										{x.name}
									</a>
								</div>
							)
						}
						else {
							
							return (
								<div key={recordNumber + "-" + value + "-" + i}>{x.name}</div>
							)
						}
					})
					}
					</td>
				)
			
			}
			rows.push(<tr key={"field-" + value}>{dataRow}</tr>)
		
		}
		tables.push(
			<table key={"table"} className="FieldedRecordViewColumn">
				<thead><tr>{theadrow}</tr></thead>
				<tbody id="bodyelem">{rows}</tbody>
			</table>
		)

	}
	else {

		for (let recordNumber in props.RecordData){
			let rows = []
			{for (let value in sortedObj){
				let data = props.RecordData[recordNumber][sortedObj[value][0]]
				if (data !== undefined){

					data = JSON.parse(data)
					rows.push(
						
						<tr key={recordNumber + "-" + value}>
						<td key={value + "-1"}>{sortedObj[value][1].name}</td>
						<td key={value + "-2"}> {data.map(function(x, i) {
							if (x.name.match(/^https?\:/)) {
								return (
									<div key={recordNumber + "-" + value + "-" + i}>
										<a className="Decorate" href={x.name}
											target="_blank">
											{x.name}
										</a>
									</div>
								)
							}
							else {
								return (
									<div key={recordNumber + "-" + value + "-" + i}>{x.name}</div>
								)
							}
						})
						}
						</td>
						</tr>
					)
				}
			
			}}
		
			tables.push(
				<table key={"table-" + recordNumber} className="FieldedRecordView">
					<thead>
						<tr>
							<th className="fieldName" ><span className="trans">Field</span></th>
							<th id="value"><span className="trans">Value</span></th>
						</tr>
					</thead>
					<tbody id="bodyelem">{rows}</tbody>
				</table>
			)
		}
	}
	return tables
	
}
class RecordView extends Component {
	constructor(props){
		super(props)
		const datasetID = props.datasetID
		const recordID = props.recordSet
		let PrevEnabled = true
		let NextEnabled = true
		const appURL = props.appURL
		if (recordID.length > 1){
			PrevEnabled = false
			NextEnabled = false
		}
		this.state = {
			fieldList: [],
			datasetID: datasetID,
			recordID: recordID,
			PrevEnabled: PrevEnabled,
			NextEnabled: NextEnabled,
			RecordData: "",
			loading: true,
			NoteArray: [],
			ViewType: "Table",
			RawRecordLinks: "",
			MainView: "Fielded",
			appURL: appURL,
			height: "auto",
			width: "auto"
		}

		this.CloseRecordWindow = this.CloseRecordWindow.bind(this)
		this.GoToPrevNextRecord = this.GoToPrevNextRecord.bind(this)
		this.SetViewType = this.SetViewType.bind(this)
	}
	fetchData(appURL, datasetID, recordID){
		FieldedRecordView(appURL, datasetID, recordID, this.abortController.signal)
			.then((data) => {
				let width = "calc(100% - 158px)"
				if (data.Summary.RecordView.classificationfields[0] === "{}"){
					width = "100%"
				}
				const RecordData = data.RecordData
				let NotesElementArray = []
				for (let info in RecordData){
					if (RecordData[info].Notes != ""){

						NotesElementArray.push(<div key={info}>{RecordData[info].Notes}</div>)
					}
				}
				let height = "calc(100% - 200px)"
				if (NotesElementArray.length === 0){
					height = "calc(100% - 78px)"
				}
				this.setState({
					classifications: data.Summary.RecordView.classificationfields,
					fieldList: data.Summary.RecordView,
					RecordData: data.RecordData,
					loading: false,
					ViewType: "Table",
					NoteArray: NotesElementArray,
					width: width,
					height: height,
				})
				
				UpdateSelectedClasses(this.state.RecordData);
			})
		RawRecordField(appURL, datasetID, recordID, this.abortController.signal)
			.then((data) => {
				this.setState({
					RawRecordLinks: data
				})
			})
	}
	componentDidMount(){
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.recordID)
	}
	componentDidUpdate(prevProps, prevState){
		if (prevProps.recordSet !== this.props.recordSet) {
			this.fetchData(this.state.appURL, this.state.datasetID, this.props.recordSet)
		}
	}
	componentWillUnmount(){
		this.abortController.abort();
	}
	abortController = new window.AbortController();

	render () {
		const mySize = {
			width: this.state.width,
			height: this.state.height
		}
		return (
			<div className="RecordViewContainer">
				<div className="DialogHeader"><div className="RecordViewIcon"></div><span className="trans">Record View</span></div>

				<div className="RecordToolbar Toolbar">
				
					<div className="RecordClassification ToolbarButton"></div>
					<div className="PrevRecord ToolbarButton" onClick={() => this.GoToPrevNextRecord("PREV")}></div>
					<div className="NextRecord ToolbarButton" onClick={() => this.GoToPrevNextRecord("NEXT")}></div>
					<div className="CloseRecord ToolbarButton" onClick={() => this.CloseRecordWindow()}></div>
					{/*
					<div className="FindInRecord ToolbarButton"></div>
					<div className="RawRecordView ToolbarButton" onClick={() => this.SwitchMainView("Raw")}></div>
					<div className="FieldedRecordViewButton Selected ToolbarButton" onClick={() => this.SwitchMainView("Fielded")}></div>
					<div className="dropdown"><div className="downArrowIcon" style={{position: "relative", top: "-7px"}}></div>
						<div id="recTable" className="dropdown-content trans" value="Record As Table" onClick={() => this.SetViewType("Table")}>Record As Table</div>
						<div id="recRow" className="dropdown-content trans" value="Record As Row" onClick={() => this.SetViewType("Row")}>Record As Row</div>
						<div id="recCol" className="dropdown-content trans" value="Record As Column" onClick={() => this.SetViewType("Column")}>Record As Column</div>
					</div>
					<div className="SetFieldOrder ToolbarButton"></div>
					<div className="HighlightToggle ToolbarButton"></div>
					*/}
				</div>
				{this.state.loading === true
					? <Loading />
					:
					<div className="MainRecordPanel">
						{this.state.classifications[0] !== "{}"?
						<div className="ClassificationsPanel">
							<Classifications ClassificationFields={this.state.classifications} RecordInfo={this.state.RecordData}/>
						</div>
						: <div></div>
						}
						<div className="RecordViewDialog" style={mySize}>
						{this.state.MainView === "Fielded" ?
							<Record RecordData={this.state.RecordData} fields={this.state.fieldList} ViewType={this.state.ViewType}/>
							: <RawRecord RecordLink={this.state.RawRecordLinks}/>
						}
						</div>
						{this.state.NoteArray.length > 0 ?
						<div className="RecordNotesContainer">
							<div className="NotesLabel">Notes about this record</div>
							<RecordNotes RecordData={this.state.RecordData}/>
						</div>
						: <div></div>}
					</div>
				}
			</div>
		)
	}
	CloseRecordWindow(){
		this.props.closeThisView()
	}
	GoToPrevNextRecord(dir){
		this.props.ChangeRecord(dir)
	}
	SetViewType(type){
		this.setState({
			ViewType: type
		})
	}
	SwitchMainView(type){
		$('.FieldedRecordViewButton, .RawRecordView').toggleClass("Selected")
		this.setState({
			MainView: type
		})
	}
}

export default RecordView